import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const FamilyInviteSchema = withDefaults({
  type: 'family-invite',
  fields: [
    {
      kind: 'attribute',
      name: 'inviteCodeTypeId',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'isValid',
    },
    {
      kind: 'attribute',
      name: 'fromDate',
    },
    {
      kind: 'attribute',
      name: 'expirationDate',
    },
    {
      kind: 'attribute',
      name: 'acceptedDate',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'family',
      type: 'family',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default FamilyInviteSchema;
